import Authentications from './Authentications';

export default Authentications;
